import { IconShoppingCartCheck } from '@tabler/icons-react';

import { TimeSeriesChart } from '@charts';

export default function SalesAmountChart({ report, timeSeries, reportLoading, currency = 'BRL' }) {
    return (
        <TimeSeriesChart
            title={`Vendas no período (${currency})`}
            icon={<IconShoppingCartCheck size={15} />}
            timeSeries={timeSeries}
            valueType="number"
            unitSingular="venda"
            unitPlural="vendas"
            report={report}
            reportLoading={reportLoading}
        />
    );
}
